import styled from 'styled-components';

import { ICarCard } from './CarCard';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.gray800};
  border: 1px solid ${({ theme }) => theme.colors.gray700};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  padding: 8px;
`;

export const Title = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin: 8px 8px 0 8px;
  color: ${({ theme }) => theme.colors.gray0};
  text-transform: capitalize;
`;

export const StatusLabel = styled.label<ICarCard.IStatus>`
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.gray900};
  border-radius: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme, status }) =>
    (status === 1 && theme.colors.primaryGreen500) ||
    (status === 5 && theme.colors.yellowOrange500) ||
    (status === 9 && theme.colors.gray0)};
  text-transform: capitalize;
`;

export const InfoContent = styled.div`
  display: flex;
  gap: 8px;
  margin: 12px 8px 0 8px;
  align-items: center;
`;

export const InfoLabel = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray200};
  text-transform: capitalize;

  :nth-child(n + 2) {
    border-left-color: ${({ theme }) => theme.colors.gray700};
    border-left-style: solid;
    border-left-width: 1px;
    padding: 0 8px;
  }
`;

export const RowContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const DateTimeContainer = styled.div`
  display: flex;
  margin: 8px;
  gap: 8px;
`;

export const DateTimeLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray200};

  span {
    font-size: 16px;
  }
`;

export const OwnerContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 0 8px;
  align-items: center;
`;

export const OwnerLabel = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
  text-transform: capitalize;

  :nth-child(2) {
    border-left-color: ${({ theme }) => theme.colors.gray700};
    border-left-style: solid;
    border-left-width: 1px;
    padding: 0 16px;
  }
`;

export const ButtonIcon = styled.span`
  font-size: 16px;
`;
